import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITable, ITableData, TablesReducer } from 'types/mainPage';

const initialState: TablesReducer = {
  tableData: [],
  tables: [],
  loading: false,
  currentTable: '',
};

export const tablesSlice = createSlice({
  initialState,
  name: 'tables',
  reducers: {
    setTables(state, action: PayloadAction<ITable[]>) {
      state.tables = action.payload;
    },
    setTableData(state, action: PayloadAction<ITableData[]>) {
      state.tableData = action.payload;
    },
    setCurrentTable(state, action: PayloadAction<string>) {
      state.currentTable = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    resetTableData(state) {
      state.tableData = [];
    },
    resetTables() {
      return initialState;
    },
  },
});

export default tablesSlice.reducer;
